import {Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';


@Component({
  selector: 'app-dashboard-widget',
  templateUrl: './dashboard-widget.component.html',
  styleUrls: ['./dashboard-widget.component.scss']
})
export class DashboardWidgetComponent implements OnInit {

  @Input()
  set cols(cols: number) {
    this.renderer.addClass(this.elementRef.nativeElement, 'col-span-' + (cols || 1));
  }

  @Input()
  set rows(rows: number) {
    this.renderer.addClass(this.elementRef.nativeElement, 'row-span-' + (rows || 1));
  }

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
  }

  ngOnInit(): void {
  }

}
